module.exports = __webpack_public_path__ + "static/media/google-play-badge.54059f2a.png";